class ME_AddClass {
 constructor() {
  this.addClass();
 }

 addClass() {
  let buttonAddClasses = $('.add-new-classes');
  let editButtonClasses = $('.editClass');
  let formContainer = $('#classes-form');
  let hideNewClass = formContainer.find('.school.new');
  if (!buttonAddClasses || !formContainer || !editButtonClasses) {
   return
  }

  buttonAddClasses.on('click', function (event) {
   event.preventDefault();
   formContainer.removeClass('hidden');
   buttonAddClasses.addClass('hidden');

   $('html').animate({
    scrollTop: ($('#classes-form').offset().top - 150),
   }, 1000);
  })

  editButtonClasses.on('click', function (event) {
   event.preventDefault();
   formContainer.removeClass('hidden');
   buttonAddClasses.addClass('hidden');
   hideNewClass.addClass('hidden');

   $('html').animate({
    scrollTop: ($('#classes-form').offset().top - 150)
   }, 1000);
  })
 }
}
